export enum BonusSettlementCustomerStatus {
    Open = 'OPEN',
    ReadyToComplete = 'READY_TO_COMPLETE',
    Completed = 'COMPLETED',
}

const translationObject: { [Key in BonusSettlementCustomerStatus]: string } = {
    [BonusSettlementCustomerStatus.Open]: 'app.bonusSettlement.Customer.status.open',
    [BonusSettlementCustomerStatus.Completed]: 'app.bonusSettlement.Customer.status.completed',
    [BonusSettlementCustomerStatus.ReadyToComplete]: 'app.bonusSettlement.Customer.status.readyToComplete',
};

export const getBonusSettlementCustomerTranslationId = (status?: BonusSettlementCustomerStatus): string => {
    return (status && translationObject[status]) || 'app.bonusSettlementSupplier.status.open';
};
